<script>
  // One person's (or group's) round avatar: the photo when there is one, else
  // the name's initial on the color hashed from `id` (`avatarBadge`), so the
  // same person looks the same everywhere. A photo that fails to load falls
  // back to the initial.
  //
  // Sized by the caller through inherited custom properties, so a page can
  // resize it per breakpoint without reaching into this component:
  // --avatar-size (40px), --avatar-font-size (17px), --avatar-font-family
  // (inherit), --avatar-shadow (none).
  import { avatarBadge } from '../../lib/logic/groups-logic.js';

  /**
   * @type {{
   *   id: string,
   *   name?: string | null,
   *   photoUrl?: string | null,
   *   alt?: string,
   *   title?: string,
   * }}
   */
  let { id, name = null, photoUrl = null, alt = '', title } = $props();

  // The URL that failed, not a flag: a new photo gets its own try.
  let failedUrl = $state(/** @type {string | null} */ (null));

  const badge = $derived(avatarBadge(id, name, photoUrl !== failedUrl ? photoUrl : null));
</script>

<span class="avatar" style:background={badge.color} {title}>
  {#if badge.photoUrl}
    <img
      src={badge.photoUrl}
      {alt}
      referrerpolicy="no-referrer"
      onerror={() => (failedUrl = badge.photoUrl)}
    />
  {:else}
    {badge.initial}
  {/if}
</span>

<style>
  .avatar {
    flex-shrink: 0;
    width: var(--avatar-size, 40px);
    height: var(--avatar-size, 40px);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    color: #fff;
    font-family: var(--avatar-font-family, inherit);
    font-size: var(--avatar-font-size, 17px);
    font-weight: 700;
    box-shadow: var(--avatar-shadow, none);
  }
  .avatar img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
</style>
